module.exports = __webpack_public_path__ + "img/910E5A_E127C3_CF1CA3_C1158F-256px.f0e6a5f9.png";